/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {createContext} from 'react';

export const ViewContext = createContext('');